import { ResolveFn } from '@angular/router'
import { inject } from '@angular/core'
import { AuthService } from './api/services'
import { catchError } from 'rxjs/operators'
import { of } from 'rxjs'

export const licenseCheckResolver: ResolveFn<any> = (route, state) => {
  const authService = inject(AuthService)
  return authService.authLicenseCheck().pipe(
    catchError((err) => {
      return of(err)
    }),
  )
}
